import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useRequestVerificationChanges = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();
  return useMutation({
    mutationFn: ({ sessionId, reason, checks }: {
      sessionId: string;
      reason: string;
      checks: Record<string, boolean>;
    }) => api.post(`onboarding/admin/queue/${sessionId}/request-verification-changes`, {
      reason,
      checks,
    }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: onboardingQKeys.queue() }),
    onError: (res: any) => handleErrors(res, "mutation"),
  });
};

